module.exports = {
	POPPINS_FONT: 'Poppins, Avenir, sans-serif',
	DM_SANS_FONT: 'DM Sans, Avenir, sans-serif',
	ROBOTO_FONT: 'Roboto, Avenir, sans-serif',
	AVENIR_FONT: 'Avenir, Roboto, sans-serif',
}
